export const RELATIONSHIPS = [
  'Agent',
  'Authorised Representative',
  'Broker',
  'Collection Agent',
  'Investigator',
  'Loss Adjuster',
  'Loss Assessor',
  'Third Party Administrator',
  'Underwriting Agency',
];

export const TITLELISTS = ['Mr', 'Ms', 'Miss', 'Mrs', 'Dr', 'Prof'];

export const LANGUAGELISTS = [
  'Arabic',
  'Cantonese',
  'Greek',
  'Hindi',
  'Italian',
  'Mandarin',
  'Punjabi',
  'Spanish',
  'Vietnamese',
  'Other',
];
